import axios from "axios";
const backendApi = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});
console.log("Main Backend API configured for:", backendApi.defaults.baseURL);

const automationApi = axios.create({
  baseURL: process.env.REACT_APP_AUTOMATION_URL,
});
console.log(
  "Automation Server API configured for:",
  automationApi.defaults.baseURL
);

// AUTHENTICATION API

// Standard Registration
export const registerUser = (userData) =>
  backendApi.post("/auth/register", userData);

// Standard Login
export const loginUser = (credentials) =>
  backendApi.post("/auth/login", credentials);

// Google Login
export const googleAuth = (credential) =>
  backendApi.post("/auth/google", { credential });

// Forgot Password
export const forgotPasswordRequest = (email) =>
  backendApi.post("/auth/forgot-password", { email });

// Reset Password (Token is part of the URL)
export const resetPassword = (token, password) =>
  backendApi.post(`/auth/reset-password/${token}`, { password });

//  USER DATA & ACTIONS API

// Gets the full user object for the dashboard
export const getUserJobInfo = (userEmail) =>
  backendApi.get("/api/user/job-info", {
    headers: { "x-user-email": userEmail },
  });

// Gets user credits for the extension pre-flight check
export const checkUserCredits = (userEmail) =>
  backendApi.get("/api/user/check-credits", {
    headers: { "x-user-email": userEmail },
  });

// Saves user's profile info
export const saveUserInfo = (email, userInfo) =>
  backendApi.post("/api/user/info", { email, userInfo });

// Saves job search preferences
export const saveJobSearchSettings = (email, settings) =>
  backendApi.post("/api/user/job-search-settings", { email, settings });

//  PAYMENT API
export const createOrder = (planName, userEmail) =>
  backendApi.post("/api/payment/create-order", { planName, userEmail });

export const processPayment = (paymentData) =>
  backendApi.post("/api/payment/process-payment", paymentData);

//  AUTOMATION SERVER API
export const pingBackend = () => automationApi.get("/ping");
export const loadSavedData = () => automationApi.get("/load-saved-data");
export const saveProfileData = (data) => automationApi.post("/save-data", data);
export const uploadResume = (formData) =>
  automationApi.post("/upload-pdf", formData);
export const fetchLogs = () => automationApi.get("/logs");
